'use client';

import { useTranslations } from 'next-intl';
import { normalizeSeverity } from '@/lib/audit/pro-report-utils';
import styles from './SeverityMark.module.css';

/**
 * The severity word with the five-segment meter, as the PDF prints it
 * (src/lib/report/pdf-document.tsx). Colours come from the report tokens in
 * src/styles/audit-theme.css so the web report and the paper agree.
 */
const LEVEL: Record<string, number> = { critical: 5, high: 4, medium: 3, low: 2 };

interface SeverityMarkProps {
  /** Any severity vocabulary: critical/high/medium/low or axe's serious/moderate/minor. */
  severity: string;
  className?: string;
}

export function SeverityMark({ severity, className }: SeverityMarkProps) {
  const t = useTranslations('report.severity');
  const level = normalizeSeverity(severity);
  const filled = LEVEL[level] ?? 0;
  return (
    <span className={`${styles.mark} ${styles[level]} ${className || ''}`}>
      <svg className={styles.meter} viewBox="0 0 24 6" width="24" height="6" aria-hidden="true" focusable="false">
        {[0, 1, 2, 3, 4].map((i) => (
          <rect key={i} x={i * 5} y={0} width={4} height={6} className={i < filled ? styles.on : styles.off} />
        ))}
      </svg>
      <span className={styles.word}>{t(level)}</span>
    </span>
  );
}
